import { combineReducers, createReducer } from "@reduxjs/toolkit"
import {
  auth_state,
  cognito_user,
  realvr_user,
} from "./actions";

const rootReducer = () => {
  const authState = createReducer(
    {},
  {
    [auth_state.type]: (state, dispatchedAction) => {
      state = dispatchedAction.payload.state;
      return state;
    }
  });

  const cognitoUser = createReducer(
    {},
    {
      [cognito_user.type]: (state, dispatchedAction) => {
        // @ts-ignore
        state = dispatchedAction.payload.user;
        return state;
      }
    });

  const realvrUser = createReducer(
    {},
    {
      [realvr_user.type]: (state, dispatchedAction) => {
        // @ts-ignore
        state = dispatchedAction.payload.user;
        return state;
      }
    });

  return combineReducers({
    authState,
    cognitoUser,
    realvrUser,
  })
}

export default rootReducer;
